import { render, staticRenderFns } from "./SelectDealableItems.vue?vue&type=template&id=27f41698&"
import script from "./SelectDealableItems.vue?vue&type=script&lang=ts&"
export * from "./SelectDealableItems.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDealableItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports